export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  artist: string;
  description: string;
  descriptionHtml: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updateDate: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
}

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'wo-de-shi-jie',
    title: '我的世界',
    author: '金敏秀',
    artist: '李在勋',
    description: '一个普通大学生意外进入虚拟游戏世界，在这个充满危险与机遇的世界中，他必须依靠自己的智慧和勇气生存下去。随着剧情深入，他逐渐发现这个世界的真相远比想象中复杂……',
    descriptionHtml: '<p>一个普通大学生意外进入虚拟游戏世界，在这个充满危险与机遇的世界中，他必须依靠自己的智慧和勇气生存下去。随着剧情深入，他逐渐发现这个世界的真相远比想象中复杂……</p><p>这是一部充满悬疑与冒险的韩国漫画，画风精美，剧情紧凑，深受读者喜爱。每周五更新，敬请期待！</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20in%20a%20fantasy%20game%20world%2C%20digital%20art%2C%20vibrant%20colors%2C%20dramatic%20lighting%2C%20anime%20inspired%20character%20design%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover%20art%2C%20high%20quality%20rendering%2C%20soft%20gradients&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    tags: ['奇幻', '冒险', '游戏', '热血'],
    status: '连载中',
    rating: 9.2,
    views: 1520000,
    updateDate: '2026-07-02',
    chapters: [
      { id: 'c1-1', title: '第1话 进入游戏', number: 1, updateDate: '2025-01-15' },
      { id: 'c1-2', title: '第2话 初次战斗', number: 2, updateDate: '2025-01-22' },
      { id: 'c1-3', title: '第3话 隐藏任务', number: 3, updateDate: '2025-01-29' },
      { id: 'c1-4', title: '第4话 公会成立', number: 4, updateDate: '2025-02-05' },
      { id: 'c1-5', title: '第5话 危机降临', number: 5, updateDate: '2025-02-12' },
      { id: 'c1-6', title: '第6话 新的盟友', number: 6, updateDate: '2025-02-19' },
      { id: 'c1-7', title: '第7话 最终决战', number: 7, updateDate: '2025-02-26' },
      { id: 'c1-8', title: '第8话 真相大白', number: 8, updateDate: '2025-03-05' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: '2',
    slug: 'ai-qing-mi-ma',
    title: '爱情密码',
    author: '朴恩静',
    artist: '崔秀妍',
    description: '两个性格迥异的人在命运的安排下相遇，一条神秘的短信将他们的人生紧紧联系在一起。这是一段跨越时空的浪漫爱情故事，温暖治愈，感人至深。',
    descriptionHtml: '<p>两个性格迥异的人在命运的安排下相遇，一条神秘的短信将他们的人生紧紧联系在一起。这是一段跨越时空的浪漫爱情故事，温暖治愈，感人至深。</p><p>韩国知名漫画家朴恩静倾情力作，画风唯美细腻，情感刻画深刻，被誉为近十年最感人韩漫之一。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20style%20illustration%20of%20a%20couple%20under%20cherry%20blossoms%2C%20pastel%20colors%2C%20soft%20romantic%20atmosphere%2C%20anime%20inspired%20webtoon%20art%2C%20clean%20white%20background%2C%20delicate%20linework%2C%20professional%20cover%20illustration&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '恋爱甜宠',
    categorySlug: 'romance',
    tags: ['恋爱', '甜宠', '治愈', '现代'],
    status: '连载中',
    rating: 9.5,
    views: 2380000,
    updateDate: '2026-07-03',
    chapters: [
      { id: 'c2-1', title: '第1话 命运的交汇', number: 1, updateDate: '2025-03-01' },
      { id: 'c2-2', title: '第2话 神秘短信', number: 2, updateDate: '2025-03-08' },
      { id: 'c2-3', title: '第3话 误会与真心', number: 3, updateDate: '2025-03-15' },
      { id: 'c2-4', title: '第4话 告白之夜', number: 4, updateDate: '2025-03-22' },
      { id: 'c2-5', title: '第5话 过去的阴影', number: 5, updateDate: '2025-03-29' },
      { id: 'c2-6', title: '第6话 雨中的拥抱', number: 6, updateDate: '2025-04-05' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    slug: 'an-ying-lie-ren',
    title: '暗影猎人',
    author: '郑宇锡',
    artist: '姜泰浩',
    description: '在黑暗势力横行的都市中，一群拥有特殊能力的猎人默默守护着人类世界。主角林浩是一名新晋猎人，他将在一次次生死任务中成长，揭开隐藏在城市背后的惊天秘密。',
    descriptionHtml: '<p>在黑暗势力横行的都市中，一群拥有特殊能力的猎人默默守护着人类世界。主角林浩是一名新晋猎人，他将在一次次生死任务中成长，揭开隐藏在城市背后的惊天秘密。</p><p>劲爆的战斗场面、扣人心弦的悬疑剧情，这部动作韩漫让人欲罢不能！</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20style%20illustration%20of%20a%20dark%20hero%20with%20supernatural%20powers%2C%20urban%20night%20setting%2C%20dramatic%20contrast%20lighting%2C%20anime%20inspired%20character%20design%2C%20clean%20background%2C%20webtoon%20cover%20art%2C%20professional%20digital%20painting&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    tags: ['动作', '热血', '都市', '超能力'],
    status: '连载中',
    rating: 9.0,
    views: 1890000,
    updateDate: '2026-07-01',
    chapters: [
      { id: 'c3-1', title: '第1话 觉醒', number: 1, updateDate: '2025-02-10' },
      { id: 'c3-2', title: '第2话 初次任务', number: 2, updateDate: '2025-02-17' },
      { id: 'c3-3', title: '第3话 暗影来袭', number: 3, updateDate: '2025-02-24' },
      { id: 'c3-4', title: '第4话 同伴', number: 4, updateDate: '2025-03-03' },
      { id: 'c3-5', title: '第5话 背叛', number: 5, updateDate: '2025-03-10' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    slug: 'xing-chen-bian-jie',
    title: '星辰边界',
    author: '吴志浩',
    artist: '韩素英',
    description: '在未来星际时代，人类已经遍布银河系。一艘探索飞船在宇宙边缘发现了一个神秘信号，由此展开了一场跨越星系的宏大冒险。科幻与人性交织的史诗巨作。',
    descriptionHtml: '<p>在未来星际时代，人类已经遍布银河系。一艘探索飞船在宇宙边缘发现了一个神秘信号，由此展开了一场跨越星系的宏大冒险。</p><p>科幻与人性交织的史诗巨作，宏大的世界观设定，精美的星际场景绘制，每一页都像一幅艺术品。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20manhwa%20illustration%20of%20astronauts%20exploring%20a%20distant%20planet%2C%20futuristic%20spaceship%20background%2C%20cosmic%20atmosphere%2C%20anime%20inspired%20webtoon%20style%2C%20clean%20composition%2C%20professional%20cover%20art%2C%20vibrant%20nebula%20colors&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '科幻未来',
    categorySlug: 'scifi',
    tags: ['科幻', '未来', '星际', '冒险'],
    status: '已完结',
    rating: 8.8,
    views: 980000,
    updateDate: '2026-06-15',
    chapters: [
      { id: 'c4-1', title: '第1话 启程', number: 1, updateDate: '2024-06-01' },
      { id: 'c4-2', title: '第2话 深空信号', number: 2, updateDate: '2024-06-08' },
      { id: 'c4-3', title: '第3话 未知领域', number: 3, updateDate: '2024-06-15' },
      { id: 'c4-4', title: '第4话 外星文明', number: 4, updateDate: '2024-06-22' },
    ],
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    slug: 'ling-yi-bi-ji',
    title: '灵异笔记',
    author: '金瑞贤',
    artist: '张美兰',
    description: '一名大学生在整理爷爷遗物时发现了一本神秘的笔记本，上面记载着各种超自然事件。随着他深入调查，恐怖的事件开始在他身边真实发生……',
    descriptionHtml: '<p>一名大学生在整理爷爷遗物时发现了一本神秘的笔记本，上面记载着各种超自然事件。随着他深入调查，恐怖的事件开始在他身边真实发生……</p><p>韩国悬疑漫画新锐之作，层层递进的恐怖氛围，令人毛骨悚然的画风，让你体验真正的寒意。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20mystery%20manhwa%20illustration%20of%20a%20student%20reading%20a%20mysterious%20old%20notebook%2C%20dark%20eerie%20atmosphere%2C%20supernatural%20elements%2C%20anime%20inspired%20webtoon%20style%2C%20clean%20composition%2C%20professional%20cover%20art%2C%20muted%20dark%20color%20palette&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    tags: ['悬疑', '惊悚', '灵异', '恐怖'],
    status: '连载中',
    rating: 8.5,
    views: 756000,
    updateDate: '2026-06-28',
    chapters: [
      { id: 'c5-1', title: '第1话 爷爷的遗物', number: 1, updateDate: '2025-05-01' },
      { id: 'c5-2', title: '第2话 第一个故事', number: 2, updateDate: '2025-05-08' },
      { id: 'c5-3', title: '第3话 镜子里的脸', number: 3, updateDate: '2025-05-15' },
    ],
    isHot: false,
    isNew: false,
  },
  {
    id: '6',
    slug: 'xiao-yuan-mi-shi',
    title: '校园秘事',
    author: '李恩智',
    artist: '朴志勋',
    description: '在一所看似平静的高中里，隐藏着不为人知的秘密。转学生韩智秀的到来，掀开了这所学校神秘面纱的一角。青春、友情与秘密交织的校园故事。',
    descriptionHtml: '<p>在一所看似平静的高中里，隐藏着不为人知的秘密。转学生韩智秀的到来，掀开了这所学校神秘面纱的一角。</p><p>青春、友情与秘密交织的校园故事，细腻的人物刻画，真实的情感表达，让人回忆起自己的青春岁月。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20illustration%20of%20students%20in%20a%20classroom%2C%20youthful%20atmosphere%2C%20warm%20sunlight%20through%20windows%2C%20anime%20inspired%20webtoon%20style%2C%20clean%20composition%2C%20professional%20cover%20art%2C%20soft%20pastel%20colors&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '校园青春',
    categorySlug: 'school',
    tags: ['校园', '青春', '友情', '日常'],
    status: '连载中',
    rating: 8.9,
    views: 1120000,
    updateDate: '2026-07-02',
    chapters: [
      { id: 'c6-1', title: '第1话 转学生', number: 1, updateDate: '2025-04-01' },
      { id: 'c6-2', title: '第2话 图书馆的秘密', number: 2, updateDate: '2025-04-08' },
      { id: 'c6-3', title: '第3话 天台上的约定', number: 3, updateDate: '2025-04-15' },
      { id: 'c6-4', title: '第4话 文化节', number: 4, updateDate: '2025-04-22' },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: '7',
    slug: 'dao-jian-feng-yun',
    title: '刀剑风云',
    author: '柳承浩',
    artist: '金泰亨',
    description: '武林纷争再起，少年剑客柳青云背负师门使命，踏上了一条充满艰险的江湖之路。传统武侠与韩国漫画的完美结合，刀光剑影中书写快意恩仇。',
    descriptionHtml: '<p>武林纷争再起，少年剑客柳青云背负师门使命，踏上了一条充满艰险的江湖之路。</p><p>传统武侠与韩国漫画的完美结合，刀光剑影中书写快意恩仇。画风豪放洒脱，打斗场面气势磅礴。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20illustration%20of%20a%20swordsman%20in%20traditional%20hanbok%2C%20dynamic%20action%20pose%2C%20ancient%20Korean%20setting%2C%20anime%20inspired%20webtoon%20style%2C%20clean%20composition%2C%20professional%20cover%20art%2C%20dramatic%20brush%20strokes&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '武侠古风',
    categorySlug: 'wuxia',
    tags: ['武侠', '古风', '江湖', '动作'],
    status: '连载中',
    rating: 9.1,
    views: 1350000,
    updateDate: '2026-06-30',
    chapters: [
      { id: 'c7-1', title: '第1话 出山', number: 1, updateDate: '2025-03-15' },
      { id: 'c7-2', title: '第2话 初入江湖', number: 2, updateDate: '2025-03-22' },
      { id: 'c7-3', title: '第3话 碧水剑法', number: 3, updateDate: '2025-03-29' },
      { id: 'c7-4', title: '第4话 宿敌', number: 4, updateDate: '2025-04-05' },
      { id: 'c7-5', title: '第5话 武林大会', number: 5, updateDate: '2025-04-12' },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: '8',
    slug: 'mo-fa-shao-nv',
    title: '魔法少女',
    author: '崔智友',
    artist: '尹素熙',
    description: '普通初中生林小美在一次意外中获得了魔法力量，从此开启了双重生活。白天是普通学生，夜晚则化身魔法少女与邪恶势力战斗。成长与责任并存的魔法物语。',
    descriptionHtml: '<p>普通初中生林小美在一次意外中获得了魔法力量，从此开启了双重生活。白天是普通学生，夜晚则化身魔法少女与邪恶势力战斗。</p><p>成长与责任并存的魔法物语，可爱的画风搭配温暖的剧情，适合全年龄段阅读。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20magical%20girl%20manhwa%20illustration%2C%20cute%20character%20with%20magical%20wand%2C%20sparkling%20effects%2C%20pastel%20color%20palette%2C%20anime%20inspired%20webtoon%20style%2C%20clean%20white%20background%2C%20professional%20cover%20art%2C%20kawaii%20aesthetic&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    tags: ['魔法', '少女', '成长', '温馨'],
    status: '已完结',
    rating: 8.7,
    views: 890000,
    updateDate: '2026-05-20',
    chapters: [
      { id: 'c8-1', title: '第1话 不可思议的相遇', number: 1, updateDate: '2024-09-01' },
      { id: 'c8-2', title: '第2话 第一次变身', number: 2, updateDate: '2024-09-08' },
      { id: 'c8-3', title: '第3话 魔法试炼', number: 3, updateDate: '2024-09-15' },
    ],
    isHot: false,
    isNew: false,
  },
  {
    id: '9',
    slug: 'zhi-chang-feng-bao',
    title: '职场风暴',
    author: '安在贤',
    artist: '金惠珍',
    description: '新人职员朴志浩进入韩国顶级企业，面对残酷的职场竞争和复杂的人际关系。他用智慧和坚持一步步向上攀登，同时也反思着现代职场文化的本质。',
    descriptionHtml: '<p>新人职员朴志浩进入韩国顶级企业，面对残酷的职场竞争和复杂的人际关系。他用智慧和坚持一步步向上攀登。</p><p>犀利的社会观察、写实的职场描绘，这部职场韩漫让无数上班族感同身受。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20office%20drama%20manhwa%20illustration%20of%20a%20young%20professional%20in%20modern%20office%2C%20corporate%20setting%2C%20serious%20expression%2C%20anime%20inspired%20webtoon%20style%2C%20clean%20composition%2C%20professional%20cover%20art%2C%20neutral%20color%20palette&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '现实题材',
    categorySlug: 'realistic',
    tags: ['职场', '现实', '成长', '社会'],
    status: '连载中',
    rating: 8.6,
    views: 670000,
    updateDate: '2026-06-25',
    chapters: [
      { id: 'c9-1', title: '第1话 入职第一天', number: 1, updateDate: '2025-06-01' },
      { id: 'c9-2', title: '第2话 职场规则', number: 2, updateDate: '2025-06-08' },
      { id: 'c9-3', title: '第3话 第一次项目', number: 3, updateDate: '2025-06-15' },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: '10',
    slug: 'hai-yang-zhi-xin',
    title: '海洋之心',
    author: '沈银河',
    artist: '刘智泰',
    description: '生活在海边小镇的少女遇到了一位来自深海的神秘少年。两个世界的碰撞，引发了一段跨越种族的唯美爱情。海洋与陆地的界限，能否阻挡两颗相爱的心？',
    descriptionHtml: '<p>生活在海边小镇的少女遇到了一位来自深海的神秘少年。两个世界的碰撞，引发了一段跨越种族的唯美爱情。</p><p>唯美的海洋画风，诗意的叙事节奏，这部奇幻爱情韩漫如同一首温柔的海洋之歌。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20illustration%2C%20mermaid%20and%20human%20by%20the%20ocean%2C%20underwater%20magical%20atmosphere%2C%20anime%20inspired%20webtoon%20style%2C%20clean%20composition%2C%20professional%20cover%20art%2C%20ethereal%20blue-green%20color%20tones&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '恋爱甜宠',
    categorySlug: 'romance',
    tags: ['恋爱', '奇幻', '海洋', '唯美'],
    status: '连载中',
    rating: 9.3,
    views: 1760000,
    updateDate: '2026-07-03',
    chapters: [
      { id: 'c10-1', title: '第1话 海边的邂逅', number: 1, updateDate: '2025-04-20' },
      { id: 'c10-2', title: '第2话 他的秘密', number: 2, updateDate: '2025-04-27' },
      { id: 'c10-3', title: '第3话 深海王国', number: 3, updateDate: '2025-05-04' },
      { id: 'c10-4', title: '第4话 两个世界的抉择', number: 4, updateDate: '2025-05-11' },
    ],
    isHot: false,
    isNew: true,
  },
];

export const newComics = comics.filter(c => c.isNew);
export const hotComics = comics.filter(c => c.isHot);